import { NgModule } from '@angular/core';
import { metaReducers, reducers } from './interfaces';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { environment } from '@lentau/core/environments';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

@NgModule({
  imports: [
    StoreModule.forRoot(reducers, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: !environment.production,
        strictActionImmutability: !environment.production,
      },
    }),
    EffectsModule.forRoot([]),
    environment.production ? [] : [StoreDevtoolsModule.instrument({ maxAge: 100, logOnly: environment.production })],
    StoreRouterConnectingModule.forRoot(),
  ],
})
export class StoreBootstrapModule {}
